// extracted by mini-css-extract-plugin
module.exports = {"pageSectionWrapper":"PageSection_pageSectionWrapper__10kkx","pageSection":"PageSection_pageSection__124sm","pageSection-background":"PageSection_pageSection-background__26t_Y"};